import { Injectable      } from '@angular/core';
import { NotifierManager } from '../managers/notifier/notifier.manager';
import { Notifier        } from '../enums/notifier/notifier.enum';
import { NotifierMessage } from '../enums/notifier/message/notifier.enum';

@Injectable
({
  providedIn: 'root'
})

export class DeviceError 
{
    constructor(private _notifier : NotifierManager) {}

    deviceNotExist() 
    {
        this._notifier.show(Notifier.ERROR, NotifierMessage.DEVICE_ACTIVATION_NOT_EXIST)
    }
}